exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-210fb116]{display:flex;justify-content:center;align-items:center;width:100%;height:100vh}svg[data-v-210fb116]{width:100px}\n", ""]);

// exports
